/* ==========================================================================
   Countdown — drives every [data-countdown] on the page
   Ships as: assets/event-countdown.js  (loaded with defer)

   Used three times: hero card, sticky bar and closing band. All read the same
   metafield-rendered dates, so they cannot disagree.

   The attribute is data-event-countdown on purpose — the theme's vendor.js
   bundles a jQuery countdown plugin that claims [data-countdown] and rewrites
   the element's innerHTML.

     data-start="{{ page.metafields.event.start_date | date: '%Y-%m-%dT11:00:00+05:30' }}"
     data-end  ="{{ page.metafields.event.end_date   | date: '%Y-%m-%dT19:00:00+05:30' }}"

   The countdown targets the real event datetime and switches itself to a
   "happening now" / "ended" state. A timer that always shows time remaining
   reads as fake and costs more trust than the urgency earns.
   ========================================================================== */

(function () {
  'use strict';

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-event-countdown]'));
  if (!roots.length) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function build(root) {
    var start = Date.parse(root.getAttribute('data-start'));
    var end   = Date.parse(root.getAttribute('data-end'));

    var units = {
      days:    root.querySelector('[data-unit="days"]'),
      hours:   root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]')
    };
    var note   = root.querySelector('.event-countdown__note');
    var srText = root.querySelector('[data-event-countdown-sr]');
    var lastMinute = -1;

    return function tick() {
      if (isNaN(start) || isNaN(end)) return true;

      var now = Date.now();

      if (now >= end) {
        root.setAttribute('data-state', 'ended');
        if (note) note.textContent = 'This exhibition has ended';
        if (srText) srText.textContent = 'This exhibition has ended.';
        return true;                                  // done — stop ticking
      }

      if (now >= start) {
        root.setAttribute('data-state', 'live');
        if (note) note.textContent = 'Happening now';
        if (srText) srText.textContent = 'The exhibition is happening now.';
        return false;
      }

      root.setAttribute('data-state', 'upcoming');

      var diff = Math.floor((start - now) / 1000);
      var d = Math.floor(diff / 86400);
      var h = Math.floor((diff % 86400) / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;

      if (units.days)    units.days.textContent    = pad(d);
      if (units.hours)   units.hours.textContent   = pad(h);
      if (units.minutes) units.minutes.textContent = pad(m);
      if (units.seconds) units.seconds.textContent = pad(s);

      // The digits are aria-hidden. Screen readers get this sentence instead,
      // refreshed at most once a minute and never inside a live region — a
      // per-second announcement would make the page unusable.
      if (srText && m !== lastMinute) {
        lastMinute = m;
        srText.textContent = d + ' days, ' + h + ' hours and ' + m +
          ' minutes until the exhibition opens.';
      }

      return false;
    };
  }

  var ticks = roots.map(build);
  var timer = null;

  function run() {
    var allDone = true;
    ticks.forEach(function (tick) { if (!tick()) allDone = false; });
    if (allDone && timer) { window.clearInterval(timer); timer = null; }
  }

  function start() {
    if (timer) return;
    run();
    if (!timer) timer = window.setInterval(run, 1000);
  }

  run();
  if (roots.some(function (r) { return r.getAttribute('data-state') !== 'ended'; })) {
    timer = window.setInterval(run, 1000);
  }

  // don't burn a timer on a backgrounded tab; resync on return
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (timer) { window.clearInterval(timer); timer = null; }
    } else {
      start();
    }
  });
})();
